// extracted by mini-css-extract-plugin
export default {"header":"style_header__YhhHz","ticketsList":"style_ticketsList__vx27W","filtersContainer":"style_filtersContainer__ZgtHG"};